import type { GrafanaLinkProps } from "@gearbox-protocol/deploy-tools-ui";
import { GrafanaLink as Base } from "@gearbox-protocol/deploy-tools-ui";
import { AdminOnly } from "api";
import type { FC } from "react";

const GrafanaLink: FC<GrafanaLinkProps> = props => {
  return (
    <AdminOnly>
      <Base {...props} />
    </AdminOnly>
  );
};

export default GrafanaLink;
